
export default {
  data() {
    return {
      activeSlide: 1,
      slidesCount: 0,
      inView: false,
      swiperOptions: {
        centeredSlides: true,
        slidesPerView: 1.2,
        initialSlide: 1,
        spaceBetween: 12,
        loop: false,
        on: {
          slideChange: () => {
            if (this.$refs.mySwiper && this.$refs.mySwiper.mySwiper) {
              this.activeSlide = this.$refs.mySwiper.mySwiper.activeIndex;
            }
          },
        },
        // onSlideChangeEnd() {
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        loopedSlides: 3,
        pagination: {
          el: ".swiper-centered-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-centered-next",
          prevEl: ".swiper-centered-prev",
        },
        thumbs: {
          swiper: this.$refs.mySwiperThumb,
        },
      },
      swiperOptionsThumb: {
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        loop: false,
        initialSlide: 1,
        loopedSlides: 3,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        on: {
          slideChange: () => {
            if (this.$refs.mySwiperThumb && this.$refs.mySwiperThumb.mySwiper) {
              this.activeSlide = this.$refs.mySwiperThumb.mySwiper.activeIndex;
            }
          },
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
        },
      },

      options: [
        {
          name: "image",
          label: "Image",
          type: "image",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
        },
        {
          name: "description",
          label: "Description",
          type: "tipTap",
        },
        {
          name: "link",
          label: "Link",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    if (
      this.$refs.mySwiper &&
      this.$refs.mySwiper.mySwiper &&
      this.$refs.mySwiper.mySwiper.activeIndex
    ) {
      this.activeSlide = this.$refs.mySwiper.mySwiper.activeIndex;
      if (this.$refs.mySwiper.$children) {
        this.slidesCount = this.$refs.mySwiper.$children.length;
      }
    }
  },
  methods: {
    setActiveSlide(val) {
      this.activeSlide = val;
    },
    goToSlide(slide) {
      this.activeSlide = slide;
      //   this.$refs.mySwiper.mySwiper.swiper.slideTo(slide, 0);
    },
  },
};
